<template>
  <div class="wrap">
    <p class="wrapTitle">论坛介绍</p>
    <p class="wrapDesc">FORUM INTRODUCTION</p>
    <ul class="wrapList">
      <li
        class="wrapListLi"
        v-for="(item, index) in info"
        :key="index"
        @click="toMore(item.link, index)"
      >
        <p class="wrapListLiName">{{ item.name }}</p>
        <p class="wrapListLiArr"><right-outlined /></p>
      </li>
      <Btn :navArr="info" :stopId="totalPage" :style="styleBtn" @fetchNav="fetchNav" />
    </ul>
  </div>
</template>

<script setup>
import Btn from '@/components/common/2023/button.vue'
import { RightOutlined } from '@ant-design/icons-vue'
import { ref, onMounted, watch } from 'vue'
import { getForun } from '@/api/2023/index.js'
const info = ref([]) // 列表信息
const pitch = ref(0) // 当前展示的列表信息
const totalPage = ref(0) // 列表页数
const currPage = ref(1) // 当前页数
const PAGE_SIZE = 5
const styleBtn = {
  position: 'absolute',
  bottom: '-62px',
  right: '0'
}
onMounted(() => {
  fetchInfo()
})

watch(currPage, async () => {
  await fetchInfo()
})
function fetchInfo() {
  getForun()
    .then((res) => {
      const { errno, data } = res.data
      if (!errno) {
        totalPage.value = Math.ceil(data.length / PAGE_SIZE)
        info.value = data.slice((currPage.value - 1) * PAGE_SIZE, currPage.value * PAGE_SIZE)
      }
      return
    })
    .catch(() => {})
}

function toMore(link, newPitch) {
  pitch.value = newPitch
  if (!link) return
  window.open(link, '_blank')
}

function fetchNav(newVal) {
  currPage.value = newVal + 1
}
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}
.multiLine {
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; //多行在这里修改数字即可
  overflow: hidden;
  /*! autoprefixer: ignore next */
  -webkit-box-orient: vertical;
}
.wrap {
  width: 100vw;
  height: 529px;
  background: #f7f8fc;
  overflow: hidden;
  padding: 30px 12px;
  &Title {
    font-size: 16px;
    font-weight: bold;
    line-height: 28px;
    color: #00ab7a;
  }
  &Desc {
    font-size: 11px;
    line-height: 20px;
    color: #3d3d3d;
    margin-bottom: 23px;
  }
  &List {
    &Li {
      position: relative;
      display: flex;
      justify-content: space-between;
      list-style: none;
      height: 58px;
      // border: 1px solid transparent;
      border-left: 6px solid #00ab7a;
      background-color: #fff;
      margin-bottom: 12px;
      padding: 15px 20px;
      &Name {
        flex: 1;
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //溢出用省略号显示
        white-space: nowrap; //溢出不换行
      }
      &Arr {
        width: 20px;
        display: inline-block;
        color: #00ab7a;
        margin-left: 36px;
        text-align: right;
      }
    }
  }
}
</style>
